import db from '../lib/firebase-db';

export const getParentOrgId = async (orgId) => {
  const orgDoc = await db.collection("orgs").doc(orgId).get();
  if (orgDoc.exists) {
    const orgData = orgDoc.data();

    // debugger;
    console.log(`in getParentOrgId from orgId ${orgId}`)
    if (orgData.parentOrgId) {
      return orgData.parentOrgId;
    }

    if(orgData.primaryOrg) {
      return orgId;
    }
  }
  // If orgId is not a child org or doesn't exist
  return null;
};

export const getCurrentOrg = (orgData, orgId) => {
  const currentOrg = orgData.find((el) => {
    return el.orgId === orgId;
  });

  return currentOrg;
};

// TODO: nest websites below orgs in store
export const getOrgWebsites = (orgId, websites) => {
  let orgWebsites = [];
  if (websites) {
    orgWebsites = websites.filter((el) => {
      return el.orgId === orgId;
    });
  }
  return orgWebsites;
};

/**
 * @deprecated Use canUseFeature(org, feature) from '@/services/feature-gates' instead.
 * This function makes extra Firestore reads. If you have the org object available
 * (from useOrg() hook), use canUseFeature() which is synchronous and doesn't hit Firestore.
 *
 * Server-side code (gcp-functions, API routes) may still need this async version.
 */
export const orgHasFeature = async (orgId, feature) => {
  console.warn(
    `[DEPRECATED] orgHasFeature() is deprecated. Use canUseFeature(org, feature) from '@/services/feature-gates' instead.`
  );
  let hasFeature = false;

  const docRef = await db.collection("orgs").doc(orgId).get();
  const orgData = docRef.data();

  // debugger;
  if (orgData) {
    const { parentOrgId, planFeatures } = orgData;
    if (parentOrgId) {
      const parentDocRef = await db
        .collection("orgs")
        .doc(parentOrgId)
        .get();
      const parentOrgData = parentDocRef.data();
      if (
        parentOrgData &&
        parentOrgData.planFeatures &&
        parentOrgData.planFeatures.features
      ) {
        hasFeature = parentOrgData.planFeatures.features.includes(feature);
      }
    } else {
      if (planFeatures && planFeatures.features) {
        hasFeature = planFeatures.features.includes(feature);
      }
    }
  }

  return hasFeature;
};

export const getUserMemberships = async (userId) => {
  const queryRef = await db
    .collection("memberships")
    .where("uid", "==", userId)
    .get();

  // console.log('getUserMemberships')
  // console.log(queryRef.docs[0].data().orgId)
  let userOrgsMemberships = [];

  for (let index = 0; index < queryRef.docs.length; index++) {
    const membership = queryRef.docs[index];
    const memberData = membership.data();

    userOrgsMemberships.push({
      orgId: memberData.orgId,
      role: memberData.role,
    });
  }

  console.log(`userOrgsMemberships is `, userOrgsMemberships);

  // const orgId = queryRef?.docs[0]?.data()?.orgId;
  // const hasFeature = docRef.data().planFeatures.features.includes(feature);
  //
  //

  // return orgId;
  return userOrgsMemberships;
};

export const getOrgPublicKey = async (orgId) => {
  const orgDoc = await db.collection("orgs").doc(orgId).get();
  if (orgDoc.exists) {
    const orgData = orgDoc.data();
    if (orgData.publicKey) {
      return orgData.publicKey;
    }
  }
  return null;
};

/**
 * Verify that a user is a member of an organization
 * Checks the memberships collection for a matching uid + orgId
 *
 * @param {string} userId - User ID to check
 * @param {string} orgId - Organization ID to verify membership for
 * @returns {Promise<boolean>} True if user is a member
 */
export const verifyOrgMembership = async (userId, orgId) => {
  if (!userId || !orgId) {
    return false;
  }

  try {
    const membershipQuery = await db
      .collection("memberships")
      .where("uid", "==", userId)
      .where("orgId", "==", orgId)
      .limit(1)
      .get();

    return !membershipQuery.empty;
  } catch (error) {
    console.error("Error verifying org membership:", error);
    return false;
  }
};
